import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { MaintenanceComponent } from './components/maintenance/maintenance.component';

@NgModule({
  declarations: [MaintenanceComponent],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    DropdownModule,
  ],
  exports: [MaintenanceComponent],
})
export class SharedModule {}
